













































import { Component, Prop, Vue } from "vue-property-decorator";

  @Component({
    components: {},
  })
  export default class AbsenceLegend extends Vue {
    @Prop() isOwnAbsences: boolean;
  }
